import React, { useEffect, useState } from "react";
import "../styles/ledger.css";
import { fetchCustomerLedger } from "../services/customerLedgerService";
import { formatAmount } from "../utils/formatAmount";

import LedgerBalanceModal from "../components/LedgerBalanceModal";
import "../styles/modal.css";
import { requestCustomerLedgerBalance} from "../services/customerRequestLedgerBalanceService";
import { confirmCustomerLedgerBalance } from "../services/customerConfirmLedgerBalanceService";
import LedgerConfirmPopup from "../components/LedgerConfirmPopup";
import { fetchCustomerLedgerBalance } from "../services/customerLedgerBalanceService.js";

const convertToInputDate = (dateStr) => {
  if (!dateStr || dateStr === "0001-01-01") return "";

  // Already yyyy-mm-dd
  if (dateStr.includes("-") && dateStr.length === 10) {
    return dateStr;
  }

  return "";
};

function Ledger() {

  const today = new Date();

  const previousMonth = new Date();
  previousMonth.setMonth(previousMonth.getMonth() - 1);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const [fromDate, setFromDate] = useState(formatDate(previousMonth));
  const [toDate, setToDate] = useState(formatDate(today));

  const [data, setData] = useState([]);

  useEffect(() => {
  const loadLedger = async () => {
    try {
      const res = await fetchCustomerLedger(fromDate, toDate);

      const formatted = res.map((item) => ({
        date: convertToInputDate(item.transaction_date),
        description: item.description,
        debit: item.debit_amount || 0,
        credit: item.credit_amount || 0,
        balance: item.balance_amount || 0,
        rowColor: item.row_color,
      }));

      setData(formatted);
    } catch (err) {
      console.error(err);
    }
  };

  loadLedger();
}, [fromDate, toDate]);

const [showPopup, setShowPopup] = useState(false);
const [ledgerBalance, setLedgerBalance] = useState(0);
const [ipAddress, setIpAddress] = useState("");
const [ledgerInfo, setLedgerInfo] = useState(null);
const [verifySuccess, setVerifySuccess] = useState(false);

const handleCheckBalance = async () => {
  try {
    const result = await fetchCustomerLedgerBalance();

    if (result.status === 0) {
      setCurrentBalance(result.info.ledger_balance);
      setShowConfirmPopup(true);
    }
  } catch (err) {
    console.error(err);
    alert("Unable to load ledger balance");
  }
};

const handleVerifyOtp = async (enteredOtp) => {
  if (!ledgerInfo) return false;

  try {
    const payload = {
      balance_amount: ledgerInfo.balance_amount,
      otp: enteredOtp,
      client_ip: ipAddress,
    };

    const res = await confirmCustomerLedgerBalance(payload);

    if (res.status === 0) {
      setVerifySuccess(true); // 🔥 show success UI

      setTimeout(() => {
        setShowPopup(false);
        setVerifySuccess(false); // reset for next time
      }, 1500);

      return true;
    } else {
      alert("Failed: " + res.message);
      return false;
    }

  } catch (error) {
    console.error(error);
    alert("OTP verification failed");
    return false;
  }
};

const [showConfirmPopup, setShowConfirmPopup] = useState(false);
const [currentBalance, setCurrentBalance] = useState(null);

const handleConfirmYes = async () => {

  setShowConfirmPopup(false);

  try {

    const ipRes = await fetch(
      "https://api.ipify.org?format=json"
    );

    const ipData = await ipRes.json();

    setIpAddress(ipData.ip);

    const result =
      await requestCustomerLedgerBalance(ipData.ip);

    setLedgerInfo(result);

    setShowPopup(true);

  } catch (err) {
    console.error(err);
    alert("Failed to request ledger balance");
  }
};

const handleConfirmNo = () => {
  setShowConfirmPopup(false);
};

  return (
    <div className="ledger-page">

      <div className="ledger-container">

        <h2>Transaction History</h2>

        <div className="date-filter">

          <div>
            <label>From</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div>
            <label>To</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

   
        </div>

        <p className="date-range">
          From {fromDate} To {toDate}
        </p>

                 <button
  className="check-balance-btn"
  onClick={handleCheckBalance}
>
  Confirm Ledger Balance
</button>

       <div className="ledger-table-wrapper">
  <table className="ledger-table">
    <thead>
      <tr>
        <th>Date</th>
        <th>Description</th>
        <th>Debit(JPY)</th>
        <th>Credit(JPY)</th>
        <th>Balance(JPY)</th>
      </tr>
    </thead>

    <tbody>
      {data.map((t, index) => (
        <tr
          key={index}
          style={{
            backgroundColor: t.rowColor || "",
          }}
        >
          <td>{t.date || "-"}</td>
          <td>{t.description}</td>

          <td className={t.debit > 0 ? "negative" : ""}>
            {formatAmount(t.debit)}
          </td>

          <td className={t.credit > 0 ? "positive" : ""}>
            {formatAmount(t.credit)}
          </td>

          <td style={{ textAlign: "right" }}>
            {formatAmount(t.balance)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>



      </div>

      <LedgerConfirmPopup
  show={showConfirmPopup}
  balance={currentBalance}
  onYes={handleConfirmYes}
  onNo={handleConfirmNo}
/>

<LedgerBalanceModal
  show={showPopup}
  ledgerInfo={ledgerInfo}
  ipAddress={ipAddress}
  onClose={() => setShowPopup(false)}
  onVerify={handleVerifyOtp}
/>

     <LedgerBalanceModal
  show={showPopup}
  ledgerInfo={ledgerInfo}
  ipAddress={ipAddress}
  onClose={() => setShowPopup(false)}
  onVerify={handleVerifyOtp}
  success={verifySuccess}
/>
    </div>

    



  );
}

export default Ledger;